import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    other: [
//         {
//             discipline: '種目1',
//             custodyLocation: '保管者または所在地1',
//             quantity: '100',
//             valuation: '1000000',
//             targetPerson: 'テスト相続人1',
//             inheritanceBequest: '相続',
//         },
//         {
//             discipline: '種目2',
//             custodyLocation: '保管者または所在地2',
//             quantity: '100',
//             valuation: '1000000',
//             targetPerson: 'テスト相続人2',
//             inheritanceBequest: '相続',
//         },
//         {
//             discipline: '種目3',
//             custodyLocation: '保管者または所在地3',
//             quantity: '100',
//             valuation: '1000000',
//             targetPerson: 'テスト相続人3',
//             inheritanceBequest: '相続',
//         }
    ]
};

const slice = createSlice({
    name: 'other',
    initialState,
    reducers: {
        setOther: (state, action) => {
            return Object.assign({}, state, { other: state.other.concat(action.payload) })
        },
        clearOther: (state, action) => {
            const newArray = Array.from(new Set([...state.other]));
            newArray.splice(action.payload, 1)
            return Object.assign({}, state, { other: newArray })
        },
    }
});


export default slice.reducer;

export const {
    setOther,
    clearOther,
} = slice.actions;
